/**
 * Permits & Licensing lifecycle status pill (♻️ clone of KORAStatusPill/CaseStatusPill). A SEPARATE
 * component rather than widening StatusPill/KORAStatusPill/CaseStatusPill because PermitStatus
 * (PSubmitted/PUnderReview/PApproved/PDenied/PInspections/PIssued/PClosed) is its own disjoint value
 * set, not a superset of either. Reuses the same token CSS vars by mapping each permit status onto
 * the nearest concern token so the visual language stays one system.
 */
import { PERMIT_STATUS_LABELS, type PermitStatus } from "../api/types.js";

const PERMIT_STATUS_TOKEN: Record<PermitStatus, string> = {
  PSubmitted: "new",
  PUnderReview: "acknowledged",
  PApproved: "inprogress",
  PDenied: "closed",
  PInspections: "inprogress",
  PIssued: "resolved",
  PClosed: "closed",
};

export function PermitStatusPill({
  status,
  size = "md",
}: {
  status: PermitStatus;
  size?: "sm" | "md";
}): JSX.Element {
  const token = PERMIT_STATUS_TOKEN[status];
  return (
    <span
      className={`td-pill td-pill--${size}`}
      style={{
        color: `var(--td-status-${token}-fg)`,
        background: `var(--td-status-${token}-bg)`,
      }}
    >
      <span
        className="td-pill__dot"
        style={{ background: `var(--td-status-${token}-dot)` }}
        aria-hidden="true"
      />
      {PERMIT_STATUS_LABELS[status]}
    </span>
  );
}
